document.addEventListener('DOMContentLoaded', function () {
  initDailyCountdown();
  initStickyBarPadding();
});

function getCountdownNumber(id) {
  var container = document.getElementById(id);
  if (!container) {
    return null;
  }

  return container.querySelector('.gp-countdown-number') || container;
}

function initDailyCountdown() {
  var hourEl = getCountdownNumber('hour');
  var minuteEl = getCountdownNumber('minute');
  var secondEl = getCountdownNumber('second');

  if (!hourEl || !minuteEl || !secondEl) {
    return;
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function updateCountdown() {
    var now = new Date();
    var midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    var diff = midnight - now;

    if (diff <= 0) {
      diff = 24 * 60 * 60 * 1000;
    }

    var hours = Math.floor(diff / (1000 * 60 * 60));
    var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((diff % (1000 * 60)) / 1000);

    hourEl.textContent = pad(hours);
    minuteEl.textContent = pad(minutes);
    secondEl.textContent = pad(seconds);
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
}

function initStickyBarPadding() {
  var page = document.querySelector('.adv-tappetino-page');
  var sticky = document.querySelector('.adv-tappetino-page .sticky-wrapper');

  if (!page || !sticky) {
    return;
  }

  function syncPadding() {
    var height = sticky.getBoundingClientRect().height;
    page.style.paddingBottom = Math.ceil(height) + 'px';
  }

  syncPadding();
  window.addEventListener('resize', syncPadding);

  if (typeof ResizeObserver !== 'undefined') {
    var observer = new ResizeObserver(syncPadding);
    observer.observe(sticky);
  }
}
